import { createBrowserClient } from '@supabase/ssr'

export function createClient() {
    const isDemo = typeof document !== 'undefined' && document.cookie.includes('is_demo=true');
    const url = process.env.NEXT_PUBLIC_SUPABASE_URL!;
    const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

    return createBrowserClient(
        url,
        key,
        isDemo ? { db: { schema: 'sandbox' } } : undefined
    )
}
